export enum PrioridadeEnum {
	BASICA = "BASICA",
	MEDIA = "MEDIA",
	ALTA = "ALTA"
}

export const DescricaoPrioridade = new Map<PrioridadeEnum, string>([
    [PrioridadeEnum.BASICA, "Básica"],
    [PrioridadeEnum.MEDIA, "Média"],
    [PrioridadeEnum.ALTA, "Alta"]
]);